export default __webpack_public_path__ + "static/6-pick-location-3e4daf63b485388224899afb9108ae36.png";